module.exports = __webpack_public_path__ + "static/media/test-screen.eb436198.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/test-screen.png
// module id = 354
// module chunks = 0